// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  height: 50px;
  border-bottom: 1px solid lightgray;
  position: sticky;
  top: 0;
  background-color: white;
  color: #000;
  z-index: 999;
}
.theme-light .navbar .left {
  display: flex;
  align-items: center;
  gap: 30px;
}
.theme-light .navbar .left span {
  font-weight: bold;
  font-size: 20px;
  color: #0B4855;
}
.theme-light .navbar .left .search {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 5px;
}
.theme-light .navbar .left .search input {
  border: none;
  width: 500px;
  background-color: transparent;
  color: #000;
}
@media (max-width: 480px) {
  .theme-light .navbar .left .search input {
    display: none;
  }
}
@media (max-width: 960px) {
  .theme-light .navbar .left .search input {
    width: 200px;
  }
}
.theme-light .navbar .right {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media (max-width: 480px) {
  .theme-light .navbar .right {
    display: none;
  }
}
.theme-light .navbar .right .user {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  position: relative;
  cursor: pointer;
}
@media (max-width: 960px) {
  .theme-light .navbar .right .user {
    display: none;
  }
}
.theme-light .navbar .right .user .dropdownMenu {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 150px;
  padding-left: 18px;
  padding-bottom: 20px;
  flex-direction: column;
  background-color: white;
  color: #000;
  position: absolute;
  top: 40px;
  left: -50px;
}
.theme-light .navbar .right .user .dropdownMenu hr {
  margin: 0px 0px;
  border: none;
  height: 0.5px;
  width: 100%;
  background-color: lightgray;
}
.theme-light .navbar .right .user .dropdownMenu .dropdownItem {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  color: #000;
}
.theme-light .navbar .right img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .navbar .right a {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  text-decoration: none;
  color: #000;
}
.theme-light .navbar .right div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border: none;
  background-color: transparent;
  color: #000;
  cursor: pointer;
}
.theme-dark .navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  height: 50px;
  border-bottom: 1px solid #444;
  position: sticky;
  top: 0;
  background-color: #222;
  color: #fffef9;
  z-index: 999;
}
.theme-dark .navbar .left {
  display: flex;
  align-items: center;
  gap: 30px;
}
.theme-dark .navbar .left span {
  font-weight: bold;
  font-size: 20px;
  color: rgb(78, 217, 113);
}
.theme-dark .navbar .left .search {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #444;
  border-radius: 5px;
  padding: 5px;
}
.theme-dark .navbar .left .search input {
  border: none;
  width: 500px;
  background-color: transparent;
  color: #fffef9;
}
@media (max-width: 480px) {
  .theme-dark .navbar .left .search input {
    display: none;
  }
}
@media (max-width: 960px) {
  .theme-dark .navbar .left .search input {
    width: 200px;
  }
}
.theme-dark .navbar .right {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media (max-width: 480px) {
  .theme-dark .navbar .right {
    display: none;
  }
}
.theme-dark .navbar .right .user {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  position: relative;
  cursor: pointer;
}
@media (max-width: 960px) {
  .theme-dark .navbar .right .user {
    display: none;
  }
}
.theme-dark .navbar .right .user .dropdownMenu {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 150px;
  padding-left: 18px;
  padding-bottom: 20px;
  flex-direction: column;
  background-color: #222;
  color: #fffef9;
  position: absolute;
  top: 40px;
  left: -50px;
}
.theme-dark .navbar .right .user .dropdownMenu hr {
  margin: 0px 0px;
  border: none;
  height: 0.5px;
  width: 100%;
  background-color: #444;
}
.theme-dark .navbar .right .user .dropdownMenu .dropdownItem {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  color: #fffef9;
}
.theme-dark .navbar .right img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .navbar .right a {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  text-decoration: none;
  color: #fffef9;
}
.theme-dark .navbar .right div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border: none;
  background-color: transparent;
  color: #fffef9;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/navbar/navbar.scss"],"names":[],"mappings":"AAqBI;ECjBA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAIM;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAFR;AAKM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;AAHR;AAKQ;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;AAHV;ADOE;ECRM;IAOI,aAAA;EAFV;AACF;ADOE;ECbM;IAWI,YAAA;EADV;AACF;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJN;ADRE;ECSE;IAMI,aAAA;EAHN;AACF;AAOM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AALR;ADhBE;ECeI;IAQI,aAAA;EAHR;AACF;AAKQ;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EAEA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACE,SAAA;EACA,WAAA;AAJV;AAMQ;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,2BAAA;AAJV;AAOQ;EACE,aAAA;EACA,uBAAA;EAGA,SAAA;EACA,eAAA;EACA,WAAA;AAPV;AAeM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAbR;AAmBM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,WAAA;AAjBR;AAqBM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;AAnBR;ADlGI;ECjBA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,MAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAsHJ;AApHI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAsHN;AApHM;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AAsHR;AAnHM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAqHR;AAnHQ;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;AAqHV;ADjHE;ECRM;IAOI,aAAA;EAsHV;AACF;ADjHE;ECbM;IAWI,YAAA;EAuHV;AACF;AAlHI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAoHN;ADhIE;ECSE;IAMI,aAAA;EAqHN;AACF;AAjHM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAmHR;ADxIE;ECeI;IAQI,aAAA;EAqHR;AACF;AAnHQ;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EAEA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACE,SAAA;EACA,WAAA;AAoHV;AAlHQ;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAoHV;AAjHQ;EACE,aAAA;EACA,uBAAA;EAGA,SAAA;EACA,eAAA;EACA,cAAA;AAiHV;AAzGM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA2GR;AArGM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;AAuGR;AAnGM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAqGR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.navbar {\n  @include themify($themes) {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n    height: 50px;\n    border-bottom: 1px solid themed(\"border\");\n    position: sticky;\n    top: 0;\n    background-color: themed(\"bg\");\n    color:themed(\"textColor\");\n    z-index: 999;\n\n    .left {\n      display: flex;\n      align-items: center;\n      gap: 30px;\n\n      span {\n        font-weight: bold;\n        font-size: 20px;\n        color: themed(\"logo\");\n      }\n\n      .search {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        border: 1px solid themed(\"border\");\n        border-radius: 5px;\n        padding: 5px;\n\n        input {\n          border: none;\n          width: 500px;\n          background-color: transparent;\n          color: themed(\"textColor\");\n\n          @include mobile{\n            display: none;\n          }\n\n          @include tablet{\n            width: 200px;\n          }\n        }\n      }\n    }\n\n    .right {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n\n      @include mobile{\n        display: none;\n      }\n\n    \n\n      .user {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        font-weight: 500;\n        position: relative;\n        cursor: pointer;\n        @include tablet{\n          display: none;\n        }\n\n        .dropdownMenu {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        \n        width: 150px;\n        padding-left: 18px;\n        padding-bottom: 20px;\n        flex-direction: column;\n        background-color: themed(\"bg\");\n        color: themed(\"textColor\");\n        position: absolute;\n          top: 40px;\n          left: -50px;\n\n        hr {\n          margin: 0px 0px;\n          border: none;\n          height: 0.5px;\n          width: 100%;  \n          background-color: themed(\"border\");\n        }\n\n        .dropdownItem {\n          display: flex;\n          align-items: flex-start;\n      \n      \n          gap: 10px;\n          cursor: pointer;\n          color: themed(\"textColor\");\n          &:hover {\n            background-color: themed(\"hover\");\n          }\n          \n        }\n      }\n      }\n      img {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n\n      span {\n      }\n\n      a {\n        display: flex;\n        justify-content: space-between;\n        gap: 12px;\n        text-decoration: none;\n        color: themed(\"textColor\");\n        // pad: 10px;\n      }\n\n      div {\n        display: flex;\n        justify-content: space-between;\n        gap: 12px;\n        border: none;\n        background-color: transparent;\n        color: themed(\"textColor\");\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
